import { Button, Tooltip } from 'antd';
import React from 'react';
import "./buttons.css";

const PrimaryButton = ({buttonText, handleOnClick, buttonDisable, icon, tooltipTitle, htmlType, form, loading, invitationForm}) => {
  return (
    <>
      <Tooltip title={tooltipTitle}>
        <Button type="primary" className={`primary-btn ${invitationForm ? "invitation-button" : ""}`} onClick={handleOnClick} disabled={buttonDisable} icon={icon} htmlType={htmlType} form={form} loading={loading}>{buttonText}</Button>
      </Tooltip>
    </>
  )
}

export default PrimaryButton;